import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Record } from '../../../../models/record';
import { CloseCitationModal, OpenCitationModal, SetSelectedCitationStyle } from './citation.actions';
import { CitationState } from './citation.state';
import { Observable } from 'rxjs';
import { CitationStyle } from '../../../services/dialogs/citation/citation.model';

@Injectable({
  providedIn: 'root',
})
export class CitationFacade {
  private readonly store = inject(Store);

  @Select(CitationState.isLoading) isLoading$: Observable<boolean>;
  @Select(CitationState.isOpen) isOpen$: Observable<boolean>;
  @Select(CitationState.record) record$: Observable<Record | null>;
  @Select(CitationState.styles) styles$: Observable<CitationStyle[]>;
  @Select(CitationState.selectedStyle) selectedStyle$: Observable<CitationStyle | undefined>;

  openCitationModal(record: Record) {
    this.store.dispatch(new OpenCitationModal(record));
  }

  closeCitationModal() {
    this.store.dispatch(new CloseCitationModal());
  }

  setSelectedCitationStyle(style: CitationStyle) {
    this.store.dispatch(new SetSelectedCitationStyle(style));
  }
}
